import Check from "@homeinstead/icons/Check";
import StarThankYou from "@homeinstead/icons/StarThankYou";
import { motion } from "motion/react";
import { cn } from "../../utils/classnames";

interface SpinningStarProps {
  className?: string;
  checkClassName?: string;
}

const SpinningStar = ({ className, checkClassName }: SpinningStarProps) => (
  <>
    <motion.div
      animate={{ rotate: "360deg" }}
      initial={{ rotate: "0deg" }}
      transition={{ duration: 12, repeat: Infinity }}
    >
      <StarThankYou className={cn("mb-2 fill-bright-future-base", className)} />
    </motion.div>
    <Check
      className={cn(
        "absolute top-[35%] left-1/2 h-7 w-8 -translate-x-1/2 -translate-y-1/2 transform stroke-2 stroke-white",
        checkClassName,
      )}
    />
  </>
);

export default SpinningStar;
